module.exports = "/_next/static/images/img__consultation-boy_desktop_horizontal-58c9a4d5f89676de982b133930383e58.png";